import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About VetBill</h1>
      <p>VetBill is a platform that ...</p>
      {/* Add more information about VetBill as needed */}
    </div>
  );
};

export default About;
